<div class="wrapper mt-[40px] flex flex-col gap-[40px]">
  <div class="flex flex-col gap-[40px] w-[711px]">
    <app-horizontal-date-picker
      (onDateSelection)="handleDateChange($event)"
      [count]="9"
      [date]="date"
      [triggerChange]="triggerDateChange"
    />
    <app-daily-reports-list
      [selectedReportId]="reportId"
    />
  </div>
</div>
